// Nutzeranfrage: die Aktionspreis-Option im Kaufdialog soll statt einer
// Checkbox ein Schiebe-/Wipp-Schalter sein - eindeutiger erkennbarer An/Aus-
// Zustand als eine kleine Checkbox in einer Liste.
export function ToggleSwitch({
  checked,
  onChange,
  label,
  disabled,
}: {
  checked: boolean;
  onChange: (value: boolean) => void;
  label: string;
  disabled?: boolean;
}) {
  return (
    <span
      role="switch"
      aria-checked={checked}
      aria-label={label}
      aria-disabled={disabled}
      tabIndex={disabled ? -1 : 0}
      className={`toggle-switch${checked ? ' on' : ''}${disabled ? ' disabled' : ''}`}
      onClick={(e) => {
        // Stoppt die Weitergabe, damit ein umschließendes klickbares Label
        // (z. B. im Kaufdialog) den Zustand nicht ein zweites Mal umschaltet.
        e.stopPropagation();
        if (!disabled) onChange(!checked);
      }}
      onKeyDown={(e) => {
        if (disabled) return;
        if (e.key === ' ' || e.key === 'Enter') {
          e.preventDefault();
          onChange(!checked);
        }
      }}
    >
      <span className="toggle-switch-thumb" aria-hidden="true" />
    </span>
  );
}
